import { AppHelper } from "../appHelper";
import { BrowserStorageType, Helper } from "../core/util/helper";
import { ReportDefinition, TargetEntityType } from "./reportMetaData";
import { ReportMetaDataHelper } from "./reportMetaDataHelper";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { General } from "../../siteManagement/general";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { FAIcon } from "../core/components/faIcon";
import { Dialog, DialogProps } from "../core/components/dialog";
import { DateTimePicker } from "../core/components/dateTimePicker";
import { Button, ButtonProps } from "../core/components/button";
import { Grid } from "../core/components/grid";
import { SheetEventType } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { createHtppServiceInstance, HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { FieldInstance } from "../core/components/field";
import { IsSearchField } from "../core/components/isSearchField";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export class ReportTest extends React.Component<ReportTestProps, any>{

    public static Open = async (entity: ReportDefinition) => {
        const getDefaultFileName = () => {
            const keys = Object.keys(entity.Name).filter(f => !Helper.isNullOrEmpty(entity.Name[f]))
            const userLang = navigator.language;
            let pKeys = keys.filter(f => userLang.toLowerCase().indexOf(f.toLowerCase()) > -1);
            if (pKeys.length > 0)
                return entity.Name[pKeys[0]];
            pKeys = keys.filter(f => f.toLowerCase().indexOf("en") > -1);
            if (pKeys.length > 0)
                return entity.Name[pKeys[0]];
            else
                return entity.Name[keys[0]];
        }
        let params = "";
        let searchUrl: string;
        let primaryKey: string;
        let field: string = null;
        switch (entity.TargetEntityType) {
            case TargetEntityType.Address:
                searchUrl = "Address";
                primaryKey = "adrnr";
                field = "adrname";
                break;
            case TargetEntityType.Assignment:
                searchUrl = "Assignment";
                primaryKey = "isguid";
                field = "bemerkung";
                if (Helper.hasValue(entity.TargetCriterias) && Helper.hasValue(entity.TargetCriterias.Codes) && entity.TargetCriterias.Codes.length > 0) {
                    params = `&knr=${entity.TargetCriterias.Codes.join(encodeURI("||"))}`//&disabled=knr
                }
                break;
            case TargetEntityType.CustomReport:
                searchUrl = "crReport";
                primaryKey = "id";
                field = "templatename";
                if (Helper.hasValue(entity.TargetCriterias) && Helper.hasValue(entity.TargetCriterias.Codes) && entity.TargetCriterias.Codes.length > 0) {
                    //params = `&knr=${entity.TargetCriterias.Codes.join("%2C")}&disabled=knr`
                }
                break;
            case TargetEntityType.Machine:
                searchUrl = "Machine";
                primaryKey = "maschnr";
                field = "maschbezeichnung";
                break;
            case TargetEntityType.Material:
                searchUrl = "Parts";
                primaryKey = "artnr";
                field = "bezeichnung";
                break;
            case TargetEntityType.Project:
                searchUrl = "Project";
                primaryKey = "projnr";
                field = "kennwort";
                break;
            case TargetEntityType.Resource:
                searchUrl = "Resource";
                primaryKey = "ressnr";
                field = "name";
                break;
            case TargetEntityType.ServiceReport:
                searchUrl = "Servicereport";
                primaryKey = "belegnr";
                break;
            case TargetEntityType.Ticket:
                searchUrl = "Procedure";
                primaryKey = "problemnr";
                field = "kommentar";
                break;
            case TargetEntityType.WeeklyReport:
                searchUrl = "weeklyreport";
                primaryKey = "belegnr";
                break;
            case TargetEntityType.TravelReport:
                searchUrl = "travelReport";
                primaryKey = "belegnr";
                break;
            default:
                console.error('Unknown type: ' + entity.TargetEntityType);
                break;
        }
        searchUrl = `DynamicSearch/Window/${searchUrl}?fullObject=true`;
        
        if (!Helper.isNullOrEmpty(params))
            searchUrl += params;


        const result = await Promise.all([
            Helper.getMetaData("reportTest"),
            ReportMetaDataHelper.getLanguages()
        ])
        const keys = Object.keys(entity.ReportFiles);
        const props: ReportTestProps = {
            reportDefinition: entity,
            context: {
                contextType: "reportTest"
            },
            dataSources: {
                languages: result[1].filter(f => keys.indexOf(f.Code) > -1)
            },
            entity: {
                DataItem: null,
                FileName: getDefaultFileName(),
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                LanguageCode: Object.keys(entity.ReportFiles)[0],
                IndividualFields: null,
                Signatures: Helper.hasValue(entity.Signatures) ? entity.Signatures.map((sig) => {
                    return {
                        DisplayName: Config.user.languageId == 0 ? "Max Mustermann": "John Doe",
                        UniqueName: sig.UniqueName,
                        Reason: ReportMetaDataHelper.getDisplayText(sig.Reasons),
                        Date: new Date()
                    }
                }) : []
            },
            field: field,
            isWindow: false,
            metadata: result[0],
            primaryKey: primaryKey,
            searchUrl: searchUrl,
            title: "Test"
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(ReportTest, props);
        });

    }

    private translations: StringKeyDictionary<string>;

    canTestEmail: boolean = false;
    common = new AppHelper();

    constructor(props: ReportTestProps) {
        super(props)
        this.canTestEmail = false && Helper.hasValue(props.reportDefinition.EmailTemplateId) && Helper.isNumber(props.reportDefinition.EmailTemplateId)
        this.common.enableHooks = false;
        this.common.init(this);
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, () => {
                this.common.setEntityDirtyState(false)
            });
    }

    createSearch = () => {
        return (
            <>
                <EntitySearch
                    field={this.props.field}
                    value={this.props.entity.DataItem}
                    primaryKey={this.props.primaryKey}
                    searchURL={this.props.searchUrl}
                    onChange={(value) => {
                        this.handleFieldChange({ model: "entity.DataItem" }, value);
                    }}
                    saveKey={this.getSaveKey()}
                />
            </>
        );
    }

    private getSaveKey = () => {
        let key = `${Config.user.userName}_${this.props.reportDefinition.Id}_${this.props.reportDefinition.TargetEntityType}`;
        if (Helper.hasValue(this.props.reportDefinition.TargetCriterias))
            key = `_${JSON.stringify(this.props.reportDefinition.TargetCriterias)}`
        return `reportTest_${Helper.getHashCode(key)}`;
    }

    createGrid = () => {
        return (
            <>
                <SignatureGrid
                    translations={this.translations}
                    signatures={this.props.entity.Signatures}
                    onChange={(signatures) => { this.handleFieldChange({ model: "entity.Signatures" }, signatures) }}
                />
            </>
        );
    }

    createTestPrint = async () => {
        if (this.common.validate()) {
            const signatures = [];
            this.props.entity.Signatures.forEach((signature) => {
                signatures.push({
                    UniqueName: signature.UniqueName,
                    DisplayName: signature.DisplayName,
                    Date: moment(signature.Date).tz(Helper.isNullOrEmpty(Config.user.timezoneIANA) ? Intl.DateTimeFormat().resolvedOptions().timeZone : Config.user.timezoneIANA).toISOString(true),
                    SignatureImage: this.createSVGSiganture(signature)
                });
            });
            const result = await HTTPService.post<JsonResultClass<number>>("ReportMetaData/Test", {
                options: {
                    DefinitionViewModel: this.props.reportDefinition,
                    DomainId: Helper.getAttributeSavely(this.props.entity.DataItem, this.props.primaryKey),
                    LanguageCode: this.props.entity.LanguageCode,
                    FileName: this.props.entity.FileName,
                    Signatures: signatures
                }
            })
            if (result.Code == 0) {
                const jobId = result.Data;
                this.downloadPDF(jobId).catch((reason: string) => {
                    NotificationHelper.showErrorMessage(reason);
                })
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private downloadPDF = (jobId: number) => {
        return new Promise<void>((resolve, reject) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);

            let intervalTokken: number = null;
            const destroy = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
                window.clearInterval(intervalTokken);
            }

            ReactDOM.render(
                <Dialog actions={[{
                    label: Config.translations.cancel,
                    action: () => {
                        destroy();
                    },
                    primary: true
                }]} open={true} title={Config.translations.createReport}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <FAIcon name="spinner" attributes={["spin", "2x"]} style={{ color: "var( --primary-color)" }} />
                    </div>
                </Dialog >, targetElement[0]
            );

            intervalTokken = window.setInterval(async () => {
                const result = await createHtppServiceInstance().noBusyIndicator().get<JsonResultClass<State>>("ReportMetaData/CheckPrintState?jobId=" + jobId);
                if (result.Code == 0) {
                    switch (result.Data) {
                        case State.Pending: 
                            break;
                        case State.Finished: 
                            Helper.openInNewBrowserTab(`${Config.baseUrl}AtlasQrReportPrint/DownloadReport?jobId=${jobId}`);
                            destroy();
                            resolve();
                            break;
                        case State.Faulted:
                            openErrorDialog(result.AdditionalData["errors"], this.translations);
                            destroy();
                            resolve();
                            break;
                    }
                } else {
                    destroy();
                    reject(result.Message);
                }
            }, 1000);
        });
    }

    private createSVGSiganture = (signature: Signature) => {

        const createSVGTextElement = (fontSize: string, yPos: string, innerText: string) => {
            const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
            //text.setAttributeNS(null, "font-style", "italic")
            text.setAttributeNS(null, "x", "10");
            text.setAttributeNS(null, "y", yPos);
            text.setAttributeNS(null, "font-size", fontSize);
            text.appendChild(document.createTextNode(innerText));
            return text;
        }

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttributeNS(null, "height", Helper.isNullOrEmpty(signature.Reason) ? "42" : "80" );
        svg.setAttributeNS(null, "width", "460px");
        if (!Helper.isNullOrEmpty(signature.Reason)) {
            const reason = createSVGTextElement("20", "28", signature.Reason);
            svg.appendChild(reason);
        }
        const name = createSVGTextElement("30", Helper.isNullOrEmpty(signature.Reason) ? "28" : "55", signature.DisplayName);
        svg.appendChild(name);
        const encodedData = window.btoa(new XMLSerializer().serializeToString(svg));
        return `data:image/svg+xml;base64,${encodedData}`;
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}

const openErrorDialog = (errors: string[], translations: StringKeyDictionary<string>) => {
    const elements = errors.map((error) => {
        return (
            <React.Fragment key={kendo.guid()}>
                <li>
                    {error}
                </li>
            </React.Fragment>
        );
    })

    const targetElement = $("<div>");
    $("body").append(targetElement);

    const dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.ReportMetadata.CouldNotCreatePdf"),
        actions: [
            {
                label: Config.translations.ok,
                action: () => {
                },
                primary: true
            }
        ],
        width: 500,
        afterClose: () => {
            ReactDOM.unmountComponentAtNode(targetElement[0]);
            targetElement[0].remove();
        }
    };
    ReactDOM.render(
        <Dialog {...dialogProps} open={true} >
            <ul style={{ listStyle: "disc", marginLeft: "20px" }}>
                {elements}
            </ul>
        </Dialog >, targetElement[0]
    );


}

interface ReportTestProps extends AppBaseProps{
    entity: TestEntity;
    reportDefinition: ReportDefinition;
    searchUrl: string;
    primaryKey: string;
    field: string;
}

interface TestEntity extends Entity {
    DataItem: any;
    FileName: string;
    LanguageCode: string;
    Signatures: Signature[];
}

interface Signature {
    UniqueName: string;
    Reason: string;
    DisplayName: string;
    Date: Date | string;
    AddressNo?: string; 
}

enum State {
    Pending = 0,
    Finished = 1,
    Faulted = 2
}

class EntitySearch extends React.Component<EntitySearchProps, {value: any}>{
    private factory = ComponentHelper.createFactory();
    constructor(props) {
        super(props)
        this.state = {
            value: null
        }
    }

    private setValue = (value: any) => {
        Helper.saveDataToStorage(this.props.saveKey, JSON.stringify(value), true, BrowserStorageType.Session);
        this.setState({ value: value }, () => {
            this.props.onChange(value)
        })
    }

    private openSearch = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(this.props.searchURL);
        sheet.bind(SheetEventType.RowClicked, (data) => {
            this.setValue(data);
        });
    }

    componentDidMount() {
        const savedData = Helper.loadDataFromStorage(this.props.saveKey, BrowserStorageType.Session);
        if (Helper.hasValue(savedData) && (typeof savedData == "object")) {
            this.setValue(savedData)
        } else {
            this.openSearch();
        }
    }

    render() {
        const valueAvailable = (field: string) => {
            return !Helper.isNullOrEmpty(Helper.getAttributeSavely(this.state.value, field))
        }
        const buttonProps: ButtonProps = {
            handleClick: this.openSearch,
            iconName: "search",
            buttonStyle: {
                marginLeft: "10px"
            }
        }
        const textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.disabled = true;
        if (Helper.hasValue(this.state.value)) {
            if (valueAvailable(this.props.field)) {
                textBoxProps.value = Helper.getAttributeSavely(this.state.value, this.props.field);
            } else if (valueAvailable(this.props.primaryKey)) {
                textBoxProps.value = Helper.getAttributeSavely(this.state.value, this.props.primaryKey)
            }
        }

        return (
            <>
                <div style={{ display: "flex" }}>
                    <TextBox {...textBoxProps} />
                    <Button {...buttonProps} />
                </div>
            </>);
    }
}

interface EntitySearchProps {
    saveKey: string;
    value: any;
    onChange: (dataItem: any) => void;
    searchURL: string;
    field: string;
    primaryKey: string;
}

class SignatureGrid extends React.Component<SignatureGridProps, { selected: Signature}>{
    private factory = ComponentHelper.createFactory();
    private gridOptions: kendo.ui.GridOptions;

    constructor(props: SignatureGridProps) {
        super(props)
        this.initApp();
        this.state = {
            selected: Helper.hasValue(props.signatures) && props.signatures.length > 0 ? props.signatures[0] : null
        }
    }

    private initApp = async () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "UniqueName",
                    title: this.props.translations["WebSMS.ReportMetadata.UniqueName"]
                },
                {
                    field: "Reason",
                    title: this.props.translations["WebSMS.ReportMetadata.Reason"]
                },
                {
                    field: "DisplayName",
                    title: this.props.translations["WebSMS.ReportMetadata.Test.SignedBy"]
                },
                {
                    field: "Date",
                    title: this.props.translations["GeoMap.PointInTime"],
                    template: "#= kendo.toString(kendo.parseDate(Date), 'G') #"
                }
            ]
        };
    }

    private createGrid = () => {
        if (Helper.hasValue(this.gridOptions)) {
            const filter = Helper.hasValue(this.state.selected) ? this.state.selected.UniqueName : null;
            return (
                <div className="flex-container" style={{ width: "100%"}}>
                    <Grid
                        preselectFilter={filter}
                        selectFilter={filter}
                        data={this.props.signatures}
                        options={this.gridOptions}
                        onSelectionChanged={this.onSelectionChange}
                        id="sigs"
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    private onSelectionChange = (dataItem: Signature) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ selected: dataItem })
        }
    }

    private createEditRegion = () => {
        if (Helper.hasValue(this.state.selected)) {
            return (
                <div className="flex-container" style={{ width: "100%", marginLeft: "15px" }}>
                    {this.createTextBox()}
                    {this.createDateTimePicker()}
                    {this.createAddressSearch()}
                </div>
            );
        } else {
            return null;
        }
    }

    private createTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.selected.DisplayName;
        props.field.triggerOnChange = true;
        props.onChange = (_, value: string) => {
            if (Helper.isNullOrEmpty(value)) {
                value = this.state.selected.UniqueName;
            }
            const gridData = this.props.signatures;
            const index = this.props.signatures.findIndex(f => f.UniqueName == this.state.selected.UniqueName);
            gridData[index].DisplayName = value;
            this.setState({ selected: gridData[index] }, () => {
                this.props.onChange(gridData)
            })
        }

        return (
            <FieldInstance label={this.props.translations["WebSMS.ReportMetadata.Test.SignedBy"]}>
                <TextBox {...props}/>
            </FieldInstance>
        )
    }

    private createDateTimePicker = () => {
        const props = this.factory.getDefaultDateTimePickerProps();
        props.value = this.state.selected.Date;
        props.onChange = (_, value) => {
            const gridData = this.props.signatures;
            const index = this.props.signatures.findIndex(f => f.UniqueName == this.state.selected.UniqueName);
            gridData[index].Date = value;
            this.setState({ selected: gridData[index] }, () => {
                this.props.onChange(gridData)
            })
        }
        props.handleEval = () => {}
        return (
            <FieldInstance label={this.props.translations["GeoMap.PointInTime"]}>
                <DateTimePicker {...props} />
            </FieldInstance>
        )
    }

    private createAddressSearch = () => {
        const props = this.factory.getDefaultSearchFieldProps();
        props.value = this.state.selected.AddressNo;
        props.onChange = (_, value, dataItem) => {

            if (Helper.isNullOrEmpty(value)) {
                value = this.state.selected.UniqueName;
            }
            const gridData = this.props.signatures;
            const index = this.props.signatures.findIndex(f => f.UniqueName == this.state.selected.UniqueName);
            gridData[index].AddressNo = value;
            this.setState({ selected: gridData[index] }, () => {
                this.props.onChange(gridData)
            })



        };

        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = "<div class='auto-complete-template-container' style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><div style='width: 100px;'>${data.AdrNr}</div><div style='width: 250px;'>${data.AdrName}</div><div>${data.Plz}  ${data.Ort}</div></div>";
        props.field.autocompleteUrl = "AddressLookup/Find";
        props.field.autocompleteDataTextField = "AdrNr";
        props.field.searchWindowUrl = "DynamicSearch/Window/Address";
        props.field.searchWindowUrlParameterName = "status";
        props.field.searchWindowUrlParameterModel = "0";

        return (
            <FieldInstance label={this.props.translations["Adresse.Adresse"]}>
                <IsSearchField {...props} />
            </FieldInstance>
        )
    }

    render() {
        return (
            <div style={{ display: "flex" }}>
                { this.createGrid() }
                { this.createEditRegion() }
            </div>
        );
    }
}

interface SignatureGridProps {
    translations: StringKeyDictionary<string>
    signatures: Signature[];
    onChange: (signatures: Signature[]) => void;
}